export default __webpack_public_path__ + "static/media/network2.9ba11b93.svg";